var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    id: "location",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.045,
    cy: 28.409,
    r: 12.5,
    fill: "#239fdb",
    fillRule: "evenodd",
    transform: "matrix(1.92 0 0 1.92 -47.126 -30.545)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0b5ecd",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textTransform: "none",
      blockProgression: "tb"
    },
    d: "M35.084 45.266a24 24 0 0 0 .422-.203 24 24 0 0 0 2.045-1.254 24 24 0 0 0 1.91-1.454 24 24 0 0 0 1.756-1.634 24 24 0 0 0 1.584-1.803 24 24 0 0 0 1.394-1.951 24 24 0 0 0 1.194-2.08 24 24 0 0 0 .98-2.19 24 24 0 0 0 .756-2.277 24 24 0 0 0 .254-1.133L31.07 12.98a10.025 10.025 0 0 0-3.177-2.145 9.926 9.926 0 0 0-3.891-.787c-5.517 0-10 4.483-10 10a9.968 9.968 0 0 0 2.932 7.068l18.15 18.15z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textTransform: "none",
      blockProgression: "tb"
    },
    d: "M15 0C9.483 0 5 4.483 5 10s4.483 10 10 10c1.641 0 3.195-.39 4.563-1.094l.812 1.375c-.396.47-.51 1.16-.188 1.719l5 8.656c.412.713 1.35.974 2.063.563.712-.411.974-1.35.563-2.063l-5-8.656c-.206-.356-.566-.588-.938-.688a1.498 1.498 0 0 0-.656-.03l-.782-1.376A10.041 10.041 0 0 0 25 10c0-5.517-4.483-10-10-10Zm0 3c2.755 0 5 2.245 5 5 0 .77-.317 1.633-.75 2.531-.433.898-.995 1.83-1.563 2.688a40.834 40.834 0 0 1-1.562 2.187c-.214.28-.401.496-.531.656A2.52 2.52 0 0 1 17 17c.314.42-.499 1.013-.813.594A1.472 1.472 0 0 0 15 17a1.477 1.477 0 0 0-1.188.594c-.318.413-1.125-.176-.812-.594a2.57 2.57 0 0 1 1.406-.938c-.13-.16-.316-.374-.531-.656-.43-.563-.995-1.33-1.563-2.187-.567-.857-1.129-1.79-1.562-2.688C10.317 9.633 10 8.771 10 8c0-2.755 2.245-5 5-5Zm0 1c-2.215 0-4 1.785-4 4 0 .472.253 1.259.656 2.094.403.834.949 1.73 1.5 2.562a39.02 39.02 0 0 0 1.531 2.125c.135.177.212.31.313.438.101-.128.178-.261.313-.438.418-.548.98-1.292 1.53-2.125.552-.832 1.098-1.728 1.5-2.562C18.748 9.259 19 8.472 19 8c0-2.215-1.785-4-4-4Zm0 1.5c1.375 0 2.5 1.125 2.5 2.5s-1.125 2.5-2.5 2.5A2.508 2.508 0 0 1 12.5 8c0-1.375 1.125-2.5 2.5-2.5zm0 1c-.834 0-1.5.666-1.5 1.5s.666 1.5 1.5 1.5 1.5-.666 1.5-1.5-.666-1.5-1.5-1.5z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(9.002 10.047)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2260ef79a0545a88df7b4352921538b8.svg";
export { ForwardRef as ReactComponent };